import { render } from "./RightBar.vue?vue&type=template&id=fbf345b4&lang=pug"
import script from "./RightBar.vue?vue&type=script&lang=js"
export * from "./RightBar.vue?vue&type=script&lang=js"

import "./RightBar.vue?vue&type=style&index=0&id=fbf345b4&lang=scss"
script.render = render

export default script
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QForm,QInput,QRadio,QToggle,QBtn,QField});
